import { render } from "./NoResultsRecommendations.vue?vue&type=template&id=6ccf2b98&ts=true"
import script from "./NoResultsRecommendations.ts?vue&type=script&lang=ts&external"
export * from "./NoResultsRecommendations.ts?vue&type=script&lang=ts&external"

import "./NoResultsRecommendations.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__